import {Image, Text, View} from "react-native";
import {TouchableOpacity} from "react-native-gesture-handler";
import {openGps} from "../../../../libs/open-gps";
import {Button} from "../../../shared/button";
import * as React from "react";
import {SectionTitle} from "./section-title";

export function AboutUs({ onPressWebsite }) {
    return <View>
        <SectionTitle>About us</SectionTitle>


        <Text style={{color: 'white', fontWeight: 'bold', fontSize: 17, marginBottom: 10}}>
            No need to move WE are here for you!
        </Text>
        <Text style={{marginBottom: 10, color: 'white', fontSize: 15}}>
            <Text style={{fontWeight: 'bold', color: '#a0ca45', fontSize: 17}}>Collection</Text> of your bins directly at home.
        </Text>
        <Text style={{marginBottom: 10, color: 'white', fontSize: 15}}>
            <Text style={{fontWeight: 'bold', color: '#a0ca45', fontSize: 17}}>Recycling</Text> of paper and cardboard packaging.
        </Text>
        <Text numberOfLines={1} style={{fontSize: 80, fontWeight: 'bold', color: 'white'}} adjustsFontSizeToFit>
            TOGETHER <Text style={{color: '#a0ca45'}}>WE</Text> CAN
        </Text>

        <View style={{backgroundColor: 'white', borderRadius: 15, marginTop: 10}}>
            <Text style={{fontSize: 15, padding: 10, color: '#1e7a4f', fontWeight: 'bold', textAlign: 'center'}}>We are here</Text>
            <View style={{borderRadius: 5, overflow: "hidden"}}>
                <TouchableOpacity onPress={() => openGps(-20.138719, 57.512999)}>
                    <Image style={{width: "100%", resizeMode: "cover", height: 150}}
                           source={require("../../../../assets/images/map.png")}></Image>
                </TouchableOpacity>
            </View>
            <View style={{padding: 10}}>
                <Button mainColor='#1e7a4f' onWhite={true} onPress={onPressWebsite}>
                    visit our Website
                </Button>
            </View>
        </View>

        <View>

        </View>
    </View>;
}